import Checkbox from '@/common/components/Checkbox';
import React, { Dispatch } from 'react';
import { twMerge } from 'tailwind-merge';

interface FilterCheckboxProps {
  isChecked: boolean;
  onChange: Dispatch<boolean>;
  label:string;
  id:string;
  name:string;
  isDisabled?: boolean;
  containerClassName?: string;
}

const FilterCheckbox: React.FC<FilterCheckboxProps> = ({ isChecked, onChange, label, id, name, isDisabled, containerClassName }) => {
  return (
    <div className={twMerge(
      "flex items-center h-[32px] gap-x-2 rounded-xl px-4 bg-white-100 shadow-[0px_0px_8px_4px_rgba(0,_0,_0,_0.2)]",
      containerClassName,
    )}>
      <Checkbox
        id={id}
        checked={isChecked}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
        name={name}
        labelClassName={twMerge("text-[12px] text-white-800 italic", isDisabled && "text-white-400")}
        label={label}
        disabled={isDisabled}
      />
    </div>
  );
};

export default FilterCheckbox;
